import { render, staticRenderFns } from "./EditMapping.vue?vue&type=template&id=7e220be2&scoped=true"
import script from "./EditMapping.vue?vue&type=script&lang=js"
export * from "./EditMapping.vue?vue&type=script&lang=js"
import style0 from "./EditMapping.vue?vue&type=style&index=0&id=7e220be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e220be2",
  null
  
)

export default component.exports